import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "toDateObj"
})
export class ToDateObj implements PipeTransform {
    transform(value: any): any {
        if (value) {
            return value.toString().replace(new RegExp(" ", "g"), "T");
        } else {
            return null;
        }
    }
}
